import React, { useEffect } from 'react';
import { trackEvent } from '../services/AnalyticsService';

const PaymentCallbackPage: React.FC = () => {
  useEffect(() => {
    // URL 파라미터에서 엑심베이 결제 결과 확인
    const urlParams = new URLSearchParams(window.location.search);
    const rescode = urlParams.get('rescode');
    const resmsg = urlParams.get('resmsg');
    const paymentData = window.location.search.startsWith('?')
      ? window.location.search.slice(1)
      : window.location.search;
    
    console.log('=== PaymentCallbackPage DEBUG ===');
    console.log('rescode:', rescode);
    console.log('resmsg:', resmsg);
    console.log('All URL params:', window.location.search);
    
    // [트래킹] Step 6: 콜백 페이지 도달
    trackEvent('eximbay_callback_reached', { 
      rescode: rescode || 'null', 
      has_opener: String(!!window.opener),
      url_search: window.location.search,
      url_hash: window.location.hash
    });
    
    // 결제 결과에 따라 다른 메시지 전송
    if (window.opener) {
      if (rescode === '0000') {
        // 결제 성공 (기존 동작 유지)
        console.log('결제 성공 - PAYMENT_SUCCESS 메시지 전송');
        // [트래킹] Step 6-1: 성공 메시지 전송
        trackEvent('eximbay_callback_post_success');
        window.opener.postMessage({ type: 'PAYMENT_SUCCESS', paymentData }, '*');
      } else {
        // 결제 실패 또는 취소
        console.log('결제 실패/취소 - PAYMENT_FAILURE 메시지 전송');
        // [트래킹] Step 6-2: 실패 메시지 전송
        trackEvent('eximbay_callback_post_failure', { rescode: rescode || 'null', resmsg: resmsg || 'null' });
        window.opener.postMessage({ 
          type: 'PAYMENT_FAILURE',
          rescode: rescode,
          resmsg: resmsg,
          paymentData,
        }, '*');
      }
    } else {
      // [트래킹] Step 6-3: window.opener 없음 (핵심 이탈 지점)
      trackEvent('eximbay_callback_no_opener', { rescode: rescode || 'null', resmsg: resmsg || 'null' });
    }
    
    // 메시지 전달 후 팝업 닫기
    setTimeout(() => {
      window.close();
    }, 100);
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-500 mx-auto mb-4"></div>
        <p className="text-gray-600">Processing payment...</p>
      </div>
    </div>
  );
};

export default PaymentCallbackPage;
